import { useCompanies, useUsers, useRoles } from '@adsk/alloy-provider';

interface EntityData {
  isLoading: boolean;
  isFound: boolean;
  name?: string;
  property?: string;
  id: string;
}

export default function useEntitiesData(ids: string[]): EntityData[] {
  const { data: users, loading } = useUsers();
  const { data: companies } = useCompanies();
  const { data: roles } = useRoles();
  let entitiesData: EntityData[] = [];
  ids.forEach((id) => {
    const user = users.find((user) => user.autodeskId === id);
    if (user) {
      const company = companies.find(
        (company) => company.id === user.companyId,
      );
      entitiesData = [
        ...entitiesData,
        {
          name: user.name,
          property: company ? company.name : undefined,
          isLoading: false,
          isFound: true,
          id: user.autodeskId,
        },
      ];
    }
    const company = companies.find((company) => company.memberGroupId === id);
    if (company) {
      entitiesData = [
        ...entitiesData,
        {
          name: company.name,
          isLoading: false,
          isFound: true,
          id: company.memberGroupId,
        },
      ];
    }
    const role = roles.find((role) => role.memberGroupId === id);
    if (role) {
      entitiesData = [
        ...entitiesData,
        {
          name: role.name,
          isLoading: false,
          isFound: true,
          id: role.memberGroupId,
        },
      ];
    }
    if (!user && !company && !role) {
      entitiesData = [
        ...entitiesData,
        {
          isLoading: loading,
          isFound: false,
          id,
        },
      ];
    }
  });
  return entitiesData;
}
